import React from 'react';
import logo from '../assets/logo-bvt.png'; // Asegúrate de tener el logo correcto en esa ruta

const Footer = () => {
  return (
    <footer className="bg-[#f9f9f9] text-gray-700 mt-16 pt-10 pb-6 px-6 rounded-t-3xl shadow-inner">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8 text-center md:text-left">
        <div className="flex flex-col items-center md:items-start">
          <img src={logo} alt="CJH Transportation Logo" className="h-12 mb-2" />
          <p className="text-sm text-gray-500 mt-2">
            Reliable freight and logistics services across the U.S.
          </p>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-3">Navigation</h3>
          <ul className="space-y-2 text-sm">
            <li><a href="/" className="hover:text-[#003366]">Home</a></li>
            <li><a href="/services" className="hover:text-[#003366]">Services</a></li>
            <li><a href="/contact" className="hover:text-[#003366]">Contact</a></li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-3">Contact Us</h3>
          <p className="text-sm">4227 S Meridian STE D, Puyallup, WA, 98737</p>
          <p className="text-sm">Phone: 253-368-4114</p>
          <p className="text-sm">Email: info@cjhtransportation.com</p> {/* puedes cambiar si tienes otro correo */}
        </div>
      </div>

      <div className="mt-8 text-center text-xs text-gray-400">
        © {new Date().getFullYear()} CJH Transportation. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
